<template>
	<div class="main-dest">
		<div id="divMenu">
			<!--<img src="@/assets/icons8-location-64.png">-->
			<Menus :menu="menu" icon="https://dsmapi.logistics.systems/dsm6gicons/icons8-location-64.png" @menuClicked="menuClicked" />
		</div>
		<div class="main-dest2">
			<!--Big Map-->
			<div id="destMap">
				<GoogleMap id="portMap" :marker_list="destCoordList" :fitBounds="destFitBounds" />
			</div>
			<!-- Table -->
			<div class="destTable" :style="{height: (showMap ? '40%':'100%')}">
				<div class="tabBox">
					<Tabulator class="tabtab" tableTitle="Port List" tableID="portTable" :tableData="fullPortList" :multiSelect="1" :selectedRow.sync="selectedPort" :currentPage.sync="destCurrentPage" :currentRowSize.sync="destCurrentRowSize" />
				</div>
			</div>
			<EntryPopup :show.sync="showPopup" :title="entryTitle" :newStyle="true" :isComponent="true" :content="popupContent" @saved="savePort"
									:viewMode="popupContent.popupData.viewMode" :errorMessages.sync="Emessages" :successMessages="successMessages"
									:updatedBy="updatedBy" :createdBy="createdBy" />
		</div>
		<!--Loader-->
		<Loader :isVisible="loading" :loadingText="loadingText" />
	</div>
</template>

<script>
/* eslint-disable */
import Tabulator from '@/components/Tabulator.vue';
import GoogleMap from '@/components/GoogleMap.vue';
import Loader from '@/components/Loader.vue';
import EntryPopup from '@/components/EntryPopup.vue';
import Tabs from '@/components/Tabs.vue';
import Menus from '@/components/Menus.vue';

export default {
	components: {
		Tabulator, GoogleMap, Loader, EntryPopup, Tabs,	Menus
	},
	//Outdated TableBox, PopupEntry
	//Issues with GoogleMap, GMapLocation, PortPopup console spam
	//This page is gonna get revamped soon so I did not add complete input checking (no red error box message for each field)
	data: function() { 
		return {
			//Loading Screen
			loading: false, //Loading Screen
			loadingText: '', //Loading Screen Text
			menu: [
				{ title: 'New Port', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png' },
				{ title: 'Edit Port', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png' },
				{ title: 'Delete Port', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png' },
				{ title: 'View Port', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png' },
				{ title: 'Show Map', icon: 'https://dsmapi.logistics.systems/dsm6gicons/Map.png' },
			],

			//Big Map
			//Coordinate List to place markers
			destCoordList: [], //Markers on current table (for big map)
			tableCoordList: [],

			//Fit all markers in map
			destFitBounds: {lat: 3.091033, lng: 101.403},
			destGeofenceIndividual: [],
			destGeofenceList: [], //Geofence on current table (for big map)
			tableGeofenceList: [],
			notPopup: true,

			//Table
			fullPortList: [], //Full detailed list
			portList: [], //List that will be displayed on table

			showMap: false,
			destCurrentPage: 1,
			destCurrentRowSize: 0,
			selectedPort: [], //Selected row on table

			//Popup Form
			showPopup: false, //Popup on/off
			entryTitle: '',		//Popup Form Title
			updatedBy: '',
			createdBy: '',
			entryMessages: [],
			successMessages: [],
			entryError: [],
			Emessages: [],
			portAction: '',
			//Popup Form

			popupContent: {
				type: 'PortPopup',
				popupData: {
					portCode: '',
					portActive: false,
					portLocation: '',
					countryCodeItems: [], selectedCountryCode: null,
					lat: '',
					lng: '',
					height: '',
					viewMode: false,
					disabledPortCode: false,
				}
			}

		}
	},
	props: {
	},
	methods: {
		//Button Actions
		menuClicked: function(e) {
			switch (e.title) {
				case 'New Port':
					this.newClicked();
					break;
				case 'Edit Port':
					this.viewEditClicked('edit');
					break;
				case 'Delete Port':
					this.deleteClicked();
					break;
				case 'View Port':
					this.viewEditClicked('view');
					break;
				case 'Show Map':
					this.$set(this.menu[4], 'title', 'Hide Map');
					this.$set(this.menu[4], 'icon', 'https://dsmapi.logistics.systems/dsm6gicons/MapHide.png')
					this.showMap = true;
					break;
				case 'Hide Map':
					this.$set(this.menu[4], 'title', 'Show Map');
					this.$set(this.menu[4], 'icon', 'https://dsmapi.logistics.systems/dsm6gicons/Map.png')
					this.showMap = false;
					break;
			}
		},
		newClicked: function () {
			this.clearForm();
			this.popupContent.popupData.disabledPortCode = false;
			this.entryTitle = 'New Port';
			this.showPopup = true;
			this.portAction = 'N';
		},
		deleteClicked: async function() {
      if (this.selectedPort[0] == undefined) {
        this.$showAlert('error', 'No Ports Selected', `Please select a record to delete`);
			} else {
				var isDelete = await this.$showAlert('warning','Delete', 'Are you sure you want to delete this?', [{text: 'Delete'}, {text: 'Cancel'}]);
				if (isDelete === 'Delete') {
					var timeNow = this.$dateTime.getDateTime(new Date(), 'yyyy-MM-ddTHH:mm:ss+08:00');
					try {
						var dataToPost = {
							action: "D",
							lastupdate: timeNow,
							Port_code: this.selectedPort[0]['Port Code'],
						};
						var portUpdate = dataToPost;
						var postUpdate = await this.$apiCallV2('/Port/SavePort', portUpdate);
					}
					catch (e) {
						console.log(e);
					}
					if (postUpdate.statusText == 'OK') {
						this.$showAlert('success', 'Delete', 'Port Deleted');
						this.getData();
					} else {
            this.$showAlert('error', 'Delete', 'Port NOT Deleted');
          }
        }
      }
		},
			viewEditClicked: function (status) {
			if (this.selectedPort[0] == undefined) {
				this.$showAlert('error', 'No Port Selected', `Please select a record to ${status}`);
			} else {
				this.retrieveTablePort();
				this.popupContent.popupData.disabledPortCode = true;
				if (status == 'edit') {
					this.entryTitle = 'Edit Port';
          this.showPopup = true;
          this.portAction = 'E';
				} else {
					this.popupContent.popupData.viewMode = true;
          this.entryTitle = 'View Port';
          this.showPopup = true;
        }
      }
    },
		//Save Port
		savePort: async function() {
			//Round to 10 decimal places to prevent lat/long from going over the character limit (15).
			this.popupContent.popupData.lat = Math.round(this.popupContent.popupData.lat * 10000000000) / 10000000000,
			this.popupContent.popupData.lng = Math.round(this.popupContent.popupData.lng * 10000000000) / 10000000000,

			this.loadingText = 'Saving';
			this.loading = true;
			var timeNow = this.$dateTime.getDateTime(new Date(), 'yyyy-MM-dd HH:mm:ss');
			
			this.Emessages = [];
			this.successMessages = [];

			// this.Emessages.push('heh');

			if (!this.popupContent.popupData.portCode.trim()) {
				this.Emessages.push('Port Code is required!');
			}
			else if (this.popupContent.popupData.portCode.length > 5) {
				this.Emessages.push('Port Code cannot exceed 5 characters!');
			}
			if (!this.popupContent.popupData.portLocation.trim()) {
				this.Emessages.push('Port Location is required!');
			}
			else if (this.popupContent.popupData.portLocation.length > 40) {
				this.Emessages.push('Port Location cannot exceed 40 characters!')
			}
			if (!this.popupContent.popupData.selectedCountryCode) {
				this.Emessages.push('Country Code is required!');
			}
			if (isNaN(parseFloat(this.popupContent.popupData.lat))) {
				this.Emessages.push('Latitude is invalid!');
			}
			else if (this.popupContent.popupData.lat.length > 15) {
				this.Emessages.push('Latitude cannot exceed 15 characters!')
			}
			if (isNaN(parseFloat(this.popupContent.popupData.lng))) {
				this.Emessages.push('Longitude is invalid!');
			}
			else if (this.popupContent.popupData.lng.length > 15) {
				this.Emessages.push('Longitude cannot exceed 15 characters!')
			}

			// console.log(this.popupContent.popupData.portActive);
			
			if (this.Emessages.length < 1) {
				try {
					var dataToPost = {
						"action": this.portAction,
						"lastupdate": timeNow,
						"Port_code": this.popupContent.popupData.portCode,
						"Port_Location": this.popupContent.popupData.portLocation,
						"Country_code": this.popupContent.popupData.selectedCountryCode['Country Code'],
						"Latitude": this.popupContent.popupData.lat,
						"Longitude": this.popupContent.popupData.lng,
						"Active": (this.popupContent.popupData.portActive) ? '1' : '0',
					};
					var portUpdate = dataToPost;
					var postUpdate = await this.$apiCallV2('/Port/SavePort', portUpdate);
					if (postUpdate[0].Results == 1) {
						this.Emessages.push(postUpdate[0].ErrMsg);
					} else { this.successMessages.push('Successfully saved Port!'); this.getData(); }
				}	catch (e) { console.log(e); }
			}


			this.loading = false;


    },
		//Save Port
		//Retrieve from table
		retrieveTablePort: async function () {
			this.clearForm();
			var retrievedPort = await this.$apiCallV2(`/Port/GetDetailsMaster?recordID=${this.selectedPort[0]['Port Code']}`);
			// console.log(retrievedPort);
			var parsedDateUpdated = retrievedPort.Port['DateUpdated'].replace('T', ' ');
      var splitDateUpdated = parsedDateUpdated.includes('.') ? parsedDateUpdated.split('.')[0] : parsedDateUpdated.split('+')[0]
			this.createdBy = retrievedPort.Port['UserID'];
			this.updatedBy = splitDateUpdated;
			this.popupContent.popupData.portCode = retrievedPort.Port['Port_code'];
			this.popupContent.popupData.portActive = retrievedPort.Port['Active'] == 1 ? true : false;
			this.popupContent.popupData.portLocation = retrievedPort.Port['Port_Location'];
			if (retrievedPort.Port['Country_Code']) {
				var selectedCountry = this.popupContent.popupData.countryCodeItems.filter((d) => { return d['Country Code'].trim() == retrievedPort.Port['Country_Code'].trim() });
				this.popupContent.popupData.selectedCountryCode = selectedCountry[0] ? selectedCountry[0] : null;
			}
			this.popupContent.popupData.lat = this.selectedPort[0]['Latitude'];
			this.popupContent.popupData.lng = this.selectedPort[0]['Longitude'];
		},
		clearForm: function () {
			this.successMessages = [];
			this.Emessages = [];
      this.popupContent.popupData.viewMode = false;
			this.updatedBy = '';
			this.createdBy = '';

			this.popupContent.popupData.portCode = '';
			this.popupContent.popupData.portActive = false;
			this.popupContent.popupData.portLocation = '';
			this.popupContent.popupData.selectedCountryCode = null;
			this.popupContent.popupData.lat = '';
			this.popupContent.popupData.lng = '';
    },
		//Update Big Map (Markers, Geofence, Viewport)
		updateBigMap: function() {
			var startIndex = (parseInt(this.destCurrentPage) - 1) * parseInt(this.destCurrentRowSize);
			var endIndex = (startIndex + parseInt(this.destCurrentRowSize)) - 1;
      this.destGeofenceList = [];
			this.destCoordList = [];
      var tempCoordList = [];

			// ALL
			if (startIndex == endIndex) {
				// Marker
				for (var i = 0; i < this.tableCoordList.length; i++) {
					tempCoordList.push(this.tableCoordList[i][1]);
				}
			}
			// Different Rows and Pages
			else {
				// Marker
				for (var i = 0; i < this.tableCoordList.length; i++) {
					if (this.tableCoordList[i][0] >= startIndex && this.tableCoordList[i][0] <= endIndex) {
            tempCoordList.push(this.tableCoordList[i][1]);
					}
				}
			}
			this.$set(this.destCoordList, 0, tempCoordList);
			//Viewport Fit all markers on map
      var latlngbounds = [];
      try {
        for (var i = 0; i < this.destCoordList[0].length; i++) {
					latlngbounds.push(this.destCoordList[0][i].position);
        }
        this.destFitBounds = latlngbounds;
      } catch (e) {
        console.log(e);
      }
    },
		//Update Big Map (Markers, Geofence, Viewport)

		//Initial Mount Data
		getData: async function () {
			//Ports
      this.loadingText = 'Getting Ports';
      this.loading = true;
			var portAPI = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'port' });
			// console.log(portAPI);
			this.fullPortList = portAPI;
			this.mountMarkerList();

			//Countries
			this.loadingText = 'Getting Countries'
      var countryAPI = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'country' });
			this.popupContent.popupData.countryCodeItems = countryAPI;

      this.loading = false;
		},
    mountMarkerList: function () {
      this.loadingText = 'Populating Table';
      try {
        for (var i = 0; i < this.fullPortList.length; i++) {
          //Marker
          var convertLat = parseFloat(this.fullPortList[i].Latitude);
          var convertLng = parseFloat(this.fullPortList[i].Longitude);
          if (
            isNaN(convertLat) == false &&
            isNaN(convertLng) == false &&
            convertLat != 0 &&
            convertLng != 0
          ) {
            this.tableCoordList.push([i, { position: { lat: convertLat, lng: convertLng } }]);
          }
        };
      } catch (e) {
        console.log(e);
      }
    },
	},
	watch: {
		destCurrentPage: function() {
			this.updateBigMap();
		},
		destCurrentRowSize: function() {
			this.updateBigMap();
		},

		showPopup: async function(val) {
			if (!val && this.$route.query['new'] && !this.popupContent.popupData.viewMode) { // When the cancel is click but is not saved (for query new=1)
        let closeWindow = await this.$showAlert('warning', 'Cancelling Port Creation', `You have not created an Port profile.\nAre you sure you want to cancel?\n\nIf you cancel, this page will close.`, [
          { "text": "Continue Creating" },
          { "text": "Cancel Creating", "color": "red", "textColor": "white" }
        ]);

        if (closeWindow == 'Cancel Creating') { // If user choose to cancel the creating process, it will close the tab
          window.close();
        } else {
          this.showPopup = true;
        }
      } else if (!val && this.$route.query['new'] && this.popupContent.popupData.viewMode) {
        window.close();
      }
		}
	},
	mounted: async function() {
		await this.getData();

		if (this.$route.query['new']) {
      this.menuClicked({ title: 'New Port' });
    }
	}
};
</script>

<style lang="scss" scoped>
.main-dest {
	width: 100%;
	height: 100%;
  padding: 3px 45px;
	overflow: hidden;
	display: flex;
}

#divMenu {
	font-size: 12px;
}

.main-dest2 {
  display: flex;
  flex-direction: column;
  width: auto;
  height: auto;
  flex: 1;
  padding-left: 5px;
  width: 100%;
  height: 100%;
  /*font-size: 12px;*/
}

.tabBox {
	width: 100%;
	height: 100%;
	position: relative;
}

.tabtab {
	width: 100%;
	height: auto;
	position: absolute;
	top: 0px;
	bottom: 38px;
}

#destMap {
	width: 100%;
	flex: 1;
}

.destTable {
	padding-bottom: 2.5%;
}
</style>